import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import { useState } from "react";

function Navbar({ selectedItems, setSelectedItems }) {
  const navItems = [
    { name: "HOME", href: "/" },
    { name: "COMMUNITY", href: "/community" },
    { name: "CONTACT", href: "/contact" },
    { name: "CAREERS", href: "/careers" },
  ];
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleItemClick = (item) => {
    setSelectedItems(item);
    setIsMenuOpen(false); // Close the menu when an item is clicked
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Split the navItems array into two parts
  const firstHalf = navItems.slice(0, Math.ceil(navItems.length / 2));
  const secondHalf = navItems.slice(Math.ceil(navItems.length / 2));

  return (
    <>
      <header>
        <nav>
          <div className={`nav-container ${isMenuOpen ? "expanded" : ""}`}>
            <div className="nav-content">
              <div className="hamburger-menu">
                <Link to="/">
                  <img
                    src="../assets/logo.svg"
                    alt="logo"
                    className="logo-mobile"
                  />
                </Link>
                <input
                  id="menu-toggle"
                  type="checkbox"
                  checked={isMenuOpen}
                  onChange={handleMenuToggle}
                />
                <label className="menu-btn" htmlFor="menu-toggle">
                  <span></span>
                </label>
                <ul className="nav-list">
                  {firstHalf.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => handleItemClick(item.name)}
                      className={
                        selectedItems === item ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link to={item.href}>{item.name}</Link>
                    </li>
                  ))}
                  <li className="nav-logo">
                    <Link to="/">
                      <img
                        src="../assets/logo.svg"
                        alt="logo"
                        className="logo"
                      />
                    </Link>
                  </li>
                  {secondHalf.map((item, index) => (
                    <li
                      key={index + firstHalf.length}
                      onClick={() => handleItemClick(item.name)}
                      className={
                        selectedItems === item ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link to={item.href}>{item.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Navbar;
